import { render } from "./bymyVideoInfo.vue?vue&type=template&id=f77d4ffc&scoped=true"
import script from "./bymyVideoInfo.vue?vue&type=script&lang=js"
export * from "./bymyVideoInfo.vue?vue&type=script&lang=js"

import "./bymyVideoInfo.vue?vue&type=style&index=0&id=f77d4ffc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77d4ffc"]])

export default __exports__